module.exports = __webpack_public_path__ + "img/developed_by.38641217.png";